<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Cancelar Aplicação de Recesso</h6>
        <i class="bi bi-x-circle close-icon" @click="fechar"></i>
      </div>

      <!-- Conteúdo -->
      <div class="modal-content">
        <div v-if="mensagemErro" class="alert alert-danger" role="alert">{{ mensagemErro }}</div>
        <ul class="list-unstyled mb-3">
          <li>
            <strong>Período de Recesso:</strong>
            {{ formatarData(recesso.data_inicio) }}
            &rarr;
            {{ formatarData(recesso.data_fim) }}
          </li>
          <li><strong>Descrição:</strong> {{ recesso.descricao }}</li>
          <li>
            <strong>Total de dias:</strong>
            {{ calcularDias(recesso.data_inicio, recesso.data_fim) }}
          </li>
        </ul>
        <p>
          Deseja realmente cancelar a aplicação deste recesso e reverter as alterações
          nas matrículas?
        </p>
      </div>

      <!-- Botões -->
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="fechar" :disabled="isSubmitting">
          Fechar
        </button>
        <button
          class="btn btn-danger"
          @click="confirmar"
          :disabled="isSubmitting"
        >
          {{ isSubmitting ? 'Processando…' : 'Confirmar' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, watch } from 'vue'
import axios from '@/services/axios'
import globalUtils from '@/utils/globalUtils'

// Define props
const props = defineProps({
  mostrar: { type: Boolean, default: false },
  recesso:  { type: Object,  required: true }
})
// Wrap props in refs to preserve reactivity
const mostrar = toRef(props, 'mostrar')
const recesso = toRef(props, 'recesso')

const emit = defineEmits({
  close: null,
  cancelado: null
})

const isSubmitting = ref(false)
const mensagemErro = ref('')

watch(mostrar, (aberto) => {
  if (aberto) mensagemErro.value = ''
})

// Formata data em pt-BR usando utilitário global
function formatarData(dateStr) {
  return globalUtils.formatarData(dateStr)
}

// Calcula dias inclusivos
function calcularDias(start, end) {
  const d1 = new Date(start)
  const d2 = new Date(end)
  return Math.floor((d2 - d1) / (24 * 60 * 60 * 1000)) + 1
}

function fechar() {
  if (isSubmitting.value) return
  emit('close')
}

async function confirmar() {
  if (isSubmitting.value) return
  mensagemErro.value = ''
  isSubmitting.value = true
  try {
    const response = await axios.post(
      `/configuracoes/recessos/${recesso.value.id}/cancelar`
    )
    // Emite dados do servidor (e.g. revertedCaseA, revertedCaseB)
    emit('cancelado', response.data)
    fechar()
  } catch (error) {
    mensagemErro.value = error.response?.data?.message || 'Não foi possível cancelar a aplicação do recesso.'
    console.error('Erro ao cancelar aplicação de recesso:', error)
  } finally {
    isSubmitting.value = false
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-container {
  background: #fff;
  width: 100%;
  max-width: 480px;
  border-radius: 4px;
  overflow: hidden;
}
.modal-header {
  background: #f5f5f5;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-icon {
  font-size: 1.3rem;
  cursor: pointer;
}
.modal-content {
  padding: 16px;
}
.modal-footer {
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.btn {
  min-width: 70px;
  padding: 6px 15px;
  font-size: 14px;
  cursor: pointer;
  border: none;
}

</style>
